import { Children, memo } from 'react';

import { Grid, PageFooter } from '@kc-console/common-ui';

import FormContentContainer from './FormContentContainer';

import type { PropsWithChildren, ReactElement, ReactNode } from 'react';
import type { PageFooterProps } from '@kc-console/common-ui';

// TODO: 나중에 타입 수정 가능
export type CreateFormContainerProps = PropsWithChildren<{
  ref?: React.Ref<HTMLDivElement>;
}>;
export type FormContentContainerProps = PropsWithChildren<{
  chart?: ReactNode;
  stepper?: ReactNode;
  summary?: ReactNode;
  topology?: ReactNode;
}>;

const FormContent = (props: FormContentContainerProps) => null;

const FormFooter = (_props: PageFooterProps) => null;

const CreateFormContainer = ({ children, ref }: CreateFormContainerProps) => {
  const safeChildren = Children.toArray(children) as ReactElement<any>[];

  const Content = safeChildren.find(child => child?.type === FormContent);
  const Footer = safeChildren.find(child => child?.type === FormFooter);

  return (
    <Grid sx={{ height: '100%' }} ref={ref}>
      <FormContentContainer {...Content?.props} />
      <PageFooter {...Footer?.props} />
    </Grid>
  );
};

export default {
  Container: memo(CreateFormContainer),
  Content: FormContent,
  Footer: FormFooter,
};
